import { Location } from 'history';

export const appleItunesAppArgument = (location: Location) => {
	const path = `path=${encodeURIComponent(location.pathname)}`;
	const hash = location.hash ? `${encodeURIComponent(location.hash)}` : '';
	return `${path}${hash}`;
};
